import { render, staticRenderFns } from "./DetailsDataMobileTable.vue?vue&type=template&id=36bbbe18&scoped=true&"
import script from "./DetailsDataMobileTable.vue?vue&type=script&lang=js&"
export * from "./DetailsDataMobileTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailsDataMobileTable.vue?vue&type=style&index=0&id=36bbbe18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bbbe18",
  null
  
)

export default component.exports